export default __webpack_public_path__ + "static/media/noImg.91518df3.png";